:host {
  /**
   * @prop --background: Background of the card
   * @prop --color: Color of the card
   */
  --ion-safe-area-left: 0px;
  --ion-safe-area-right: 0px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: block;
  position: relative;
  background: var(--background);
  color: var(--color);
  font-family: var(--ion-font-family, inherit);
  contain: content;
  overflow: hidden;
}

:host(.ion-color) {
  background: var(--ion-color-base);
  color: var(--ion-color-contrast);
}

:host(.card-disabled) {
  cursor: default;
  opacity: 0.3;
  pointer-events: none;
}

.card-native {
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  text-decoration: inherit;
  text-indent: inherit;
  text-overflow: inherit;
  text-transform: inherit;
  text-align: inherit;
  white-space: inherit;
  color: inherit;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  display: block;
  width: 100%;
  min-height: var(--min-height);
  transition: var(--transition);
  border-width: var(--border-width);
  border-style: var(--border-style);
  border-color: var(--border-color);
  outline: none;
  background: inherit;
}

.card-native::-moz-focus-inner {
  border: 0;
}

button, a {
  cursor: pointer;
  user-select: none;
  -webkit-user-drag: none;
}

ion-ripple-effect {
  color: var(--ripple-color);
}

:host {
  --background: var(--ion-card-background, var(--ion-item-background, var(--ion-background-color, #fff)));
  --color: var(--ion-card-color, var(--ion-item-color, var(--ion-color-step-550, #737373)));
  -webkit-margin-start: 10px;
  margin-inline-start: 10px;
  -webkit-margin-end: 10px;
  margin-inline-end: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}